// src/router/recintoAlfandegados.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['coordenador_operacional']

const recintoAlfandegadosBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Recintos Alfandegados',
        to: 'RecintoAlfandegados'
    }
]

export default [
    {
        path: '/recintos-alfandegados',
        name: 'RecintoAlfandegados',
        component: () => import('@/views/RecintosAlfandegados/RecintoAlfandegadoListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Recintos Alfandegados',
            breadcrumb: recintoAlfandegadosBreadCrumb
        },
    },
    {
        path: '/recintos-alfandegados/novo',
        name: 'RecintoAlfandegadoNovo',
        component: () => import('@/views/RecintosAlfandegados/NovoRecintoAlfandegadoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Novo Recinto Alfandegado',
            breadcrumb: [
                ...recintoAlfandegadosBreadCrumb,
                {
                    label: 'Novo Cliente',
                    to: 'ClienteNovo'
                }
            ]
        }
    },
    {
        path: '/recintos-alfandegados/:id/edit',
        name: 'RecintoAlfandegadoEdit',
        component: () => import('@/views/RecintosAlfandegados/NovoRecintoAlfandegadoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes do Recinto Alfandedago',
            breadcrumb: [
                ...recintoAlfandegadosBreadCrumb,
                {
                    label: 'Novo RecintoAlfandegado',
                    to: 'RecintoAlfandegadoNovo'
                }
            ]
        }
    }

];
